/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Seat_Types_Card_DescriptionInputs */



/**
* | output |
* | --- |
* | "Everyone in your team has a seat of one type. You always pay for at least {count} seats – your base seats – even if some are empty. A free seat can be given ..." |
*
* @param {Seat_Types_Card_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_types_card_description = /** @type {((inputs: Seat_Types_Card_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Types_Card_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Jede Person in Ihrem Team hat einen Platz eines bestimmten Typs. Sie bezahlen immer mindestens ${i?.count} Plätze – Ihre Basisplätze –, auch wenn einige frei sind. Ein freier Platz kann ohne Zusatzkosten an ein neues Mitglied vergeben werden.`)
	return /** @type {LocalizedString} */ (`Everyone in your team has a seat of one type. You always pay for at least ${i?.count} seats – your base seats – even if some are empty. A free seat can be given to a new member at no extra cost.`)
});